import * as React from 'react'
import { Label } from 'reactstrap'
import * as ReactDOM from 'react-dom'

type InputProps = {
  name: string,
  checked: boolean,
  indeterminate?: boolean,
  disabled?: boolean,
  className?: string,
  onChange: React.ChangeEventHandler<HTMLInputElement>,
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  id?: string
}

class Input extends React.Component<InputProps> {
  componentWillReceiveProps(props: InputProps) {
    this.update(props)
  }

  componentDidMount() {
    this.update(this.props)
  }

  update = (props: InputProps) => {
    (ReactDOM.findDOMNode(this) as HTMLInputElement).indeterminate = props.indeterminate || false
  }

  render() {
    const { name, onChange, disabled, className, checked, onBlur, id } = this.props

    return (
      <input
        id={id}
        type="checkbox"
        name={name}
        checked={checked}
        className={className}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
      />
    )
  }
}

interface ICheckboxProps {
  id?: string,
  text?: string | React.ReactNode
  name: string,
  checked: boolean,
  indeterminate?: boolean,
  className?: string,
  indicatorClassName?: string,
  disabled?: boolean
  onChange: React.ChangeEventHandler<HTMLInputElement>
  onBlur?: React.FocusEventHandler<HTMLInputElement>
}

export const Checkbox: React.SFC<ICheckboxProps> = (props) => {
  const { id, text, name, checked, indeterminate, disabled,
    onChange, onBlur, className = '', indicatorClassName = '' } = props

  return (
    <Label className={`custom-control custom-checkbox ${className}`}>
      <Input
        id={id}
        name={name}
        checked={checked}
        indeterminate={indeterminate}
        className="custom-control-input"
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
      />
      <span className={`custom-control-indicator ${indicatorClassName}`} />
      <span className="custom-control-description">{text}</span>
    </Label>
  )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/components/Checkbox.tsx